<template>
  <div id="page-user-view">
    <div class="vx-col flex-1" id="account-info-col-1">
      <shipblu-card :cardLoading="dataLoading" class="mb-base p-5">
        <p class="h4 mb-6">{{$t('Merchant Fulfillment Pricing')}}</p>
        <div class="vx-row mb-2">
          <div class="vx-col w-1/3">
            <label class="mt-10 font-semibold">{{$t('Pricing Package')}}</label>
          </div>
          <div class="vx-col w-2/3">
            <template v-if="!editable">
              <a v-if="data.pricing_lookup_fulfillment && data.pricing_lookup_fulfillment.package" :href="data.pricing_lookup_fulfillment.package.google_sheet_url" target="blank">{{data.pricing_lookup_fulfillment.package.name}}</a>
              <p v-else>{{$t('No Pricing Package')}}</p>
            </template>
            <v-select v-else autocomplete="nofill" class="select-large w-full" name="pricing package" v-model="data.pricing_lookup_fulfillment.package"
              v-validate="'required'" :placeholder="$t('Pricing Package')" label="name" :options="pricingPackages"/>
            <span class="text-danger text-sm" v-show="errors.has('pricing package')">{{ errors.first('pricing package') }}</span>
          </div>
        </div>
        <div v-if="$store.state.AppActiveUser.userRole === 'admin' || $store.state.AppActiveUser.userRole === 'customer-support' || $store.state.AppActiveUser.userRole === 'commercial-admin'" class="flex flex-wrap items-center justify-end mt-6">
          <vs-button class="ml-auto mt-2" v-if="!editable" @click="editable = true">{{data.pricing_lookup_fulfillment && data.pricing_lookup_fulfillment.package ? $t('Edit') : $t('Add')}}</vs-button>
          <vs-button class="ml-auto mt-2" v-if="editable" @click="updateMerchant()">{{$t('Save')}}</vs-button>
          <vs-button class="ml-4 mt-2" v-if="editable" @click="cancelEdit()" type="border" color="warning">{{$t('Cancel')}}</vs-button>
        </div>
      </shipblu-card>
    </div>
  </div>
</template>

<script>
import {sendFulfillmentRequest} from '../../../http/axios/requestHelper.js'
import i18nData from '../../../i18n/i18nData.js'
import vSelect from 'vue-select'
import common  from '@/assets/utils/common'
import ShipbluCard from '../../../layouts/components/ShipbluCard.vue'

export default {
  data () {
    return {
      editable: false,
      dataLoading: false,
      pricingPackages: [],
      data: {
        pricing_lookup_fulfillment: {
          package: {},
          status: ''
        }
      }
    }
  },
  methods: {
    cancelEdit () {
      this.editable = false
      this.loadMerchant()
    },
    getOrderStatusColor (order) {
      return common.getOrderStatusColor(this.getStatusLabel(order))
    },
    getStatusLabel (order) {
      return common.getStatusLabel(order, this.$store.state.AppActiveUser.userRole)
    },
    loadPricingPackages () {
      sendFulfillmentRequest(false, false, this, 'api/v1/fc/pricing-packages/', 'get', null, true,
        (response) => {
          this.pricingPackages = []
          response.data.results.forEach(element => {
            if (element.status === 'ready') {
              this.pricingPackages.push(element)
            }
          })
        }
      )
    },
    loadMerchant () {
      this.dataLoading = true
      sendFulfillmentRequest(true, false, this, `api/v1/fc/merchants/${this.$route.params.merchantID}/`, 'get', null, true,
        (response) => {
          this.data = response.data
          if (!this.data.pricing_lookup_fulfillment) {
            this.data.pricing_lookup_fulfillment = {
              package: null,
              status: ''
            }
          } else if (!this.data.pricing_lookup_fulfillment.package) {
            this.data.pricing_lookup_fulfillment.package = null
          }
          this.dataLoading = false
        }, (error) => {
          common.notifyResponseError(this, error)
          this.dataLoading = false
        }
      )
    },
    updateMerchant () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const pricingObj = {
            pricing_package: this.data.pricing_lookup_fulfillment.package.id
          }
          sendFulfillmentRequest(true, false, this, `api/v1/fc/merchants/${this.$route.params.merchantID}/`, 'patch', pricingObj, true,
            () => {
              this.editable = false
              this.$vs.notify({
                color:'success',
                title:i18nData[this.$i18n.locale]['Success'],
                text:i18nData[this.$i18n.locale]['Merchant'] + i18nData[this.$i18n.locale][' has been updated successfully!'],
                position: 'top-center'
              })
              this.loadMerchant()
            }
          )
        }
      })
    }
  },
  components: {
    vSelect,
    ShipbluCard 
  },
  created () {
    this.loadPricingPackages()
    this.loadMerchant()
  }
}
</script>
